<template>
  <div class="input-group input-no-border">
      <!-- <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon2">RM</span>
      </div> -->
      <money v-model.lazy="price" v-bind="money" class="form-control text-right" @change.native="setData" :disabled="disabled"></money>
  </div>
</template>

<script>
  import {Money} from 'v-money'

  export default {
    data () {
      return {
        price:0,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false
        }
      }
    },
    components: {Money},
    props:["disabled",'bus'],
    methods:{
      init(price){
        this.price = parseFloat(price);
      },
      setData(){
        this.$emit('set-price', this.price);
      }
    },
    mounted(){
      this.bus.$on('init', this.init);
    }
  }
</script>